<template>
  <div v-bind:class="{ 'op--modal-container':true, hide: !sms.showForm }" @click="closeSMSForm">
    <div class="op--modal">
      <div class="op--modal-content">
        <div @click.stop class="notification-form">
          <div class="heading">{{ $t('provider.list.sms.header') }}</div>
          <div class="nf-content" @click="closeEmoji">
            <div v-show="!sms.errorMsg && !sms.success">
              <div :class="{'data-field':true, 'has-error':!!sms.targetMessage, 'reduce-margin':sms.target === 'geofence'}"
                v-if="!hideTargetOption">
                <div class="label">{{ $t('consumer.list.target') }}:</div>
                <select v-model="sms.target"  @change="targetUpdate" :disabled="sms.geofence.loading">
                  <option value="all" v-if="!removeAllActiveUserOption">All Active User</option>
                  <option value="selected">{{ $t('consumer.list.selectedUser') }}</option>
                  <option value="geofence" v-if="showGeofenceOption">Geofence</option>
                </select>
                <span class="error-msg">{{ sms.targetMessage }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!sms.geofence.error.type, 'reduce-margin':sms.target === 'geofence'}"
                v-if="sms.geofence.show">
                <div class="label">Geofence Type:</div>
                <select v-model="sms.geofence.type" @change="updateGeofenceList" :disabled="sms.geofence.loading">
                  <option value="airport">Airport</option>
                  <option value="staging">Staging</option>
                  <option value="serviceArea">Service Area</option>
                </select>
                <span class="error-msg">{{ sms.geofence.error.type }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!sms.geofence.error.brand, 'reduce-margin':sms.target === 'geofence'}"
                v-if="sms.geofence.show && sms.geofence.type === 'serviceArea'">
                <div class="label">Brand:</div>
                <select v-model="sms.geofence.brand" @change="updateGeofenceList" :disabled="sms.geofence.loading">
                  <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{brand.name}}</option>
                </select>
                <span class="error-msg">{{ sms.geofence.error.brand }}</span>
              </div>

              <div :class="{'data-field':true, 'has-error':!!sms.geofence.error.id}"
                v-if="sms.geofence.show && ((sms.geofence.type === 'serviceArea' && sms.geofence.brand) || (sms.geofence.type && sms.geofence.type !== 'serviceArea'))">
                <div class="label">Geofence:</div>
                <div class="select-box">
                  <div class="select-loader" v-if="sms.geofence.loading">
                    <i class="fas fa-spinner fa-spin"></i>
                    Loading...
                  </div>
                  <select v-model="sms.geofence.id" :disabled="sms.geofence.loading">
                    <option v-for="geofence in sms.geofence.list" :key="geofence.id" :value="geofence.id">{{geofence.name}}</option>
                  </select>
                </div>
                <span class="error-msg">{{ sms.geofence.error.id }}</span>
              </div>

              <!-- <div v-show="sms.target === 'all'"
                :class="{'data-field':true, 'has-error':!!sms.brandErrorMsg}">
                <div class="label">{{ $t('consumer.list.brands') }}:</div>
                <select v-model="sms.brand">
                  <option v-for="brand in brands" :value="brand.id">{{ brand.name }}</option>
                </select>
                <span class="error-msg">{{ sms.brandErrorMsg }}</span>
              </div> -->

              <label v-if="false">
                <input type="checkbox" v-model='sms.isPushNotif' />
                {{ $t('consumer.list.pushNotif') }}
              </label>
              <label v-if="false">
                <input type="checkbox" v-model='sms.isSendEmail' />
                {{ $t('consumer.list.email') }}
              </label>

              <!-- <div :class="{'data-field':true, 'has-error':!!sms.titleError}">
                <div class="label">{{ $t('consumer.list.title') }}:</div>
                <input type="text" v-model="sms.title" class="input" />
                <span class="error-msg">{{ sms.titleError }}</span>
              </div> -->

              <div class="textarea-box">
                <textarea v-model='sms.message' rows="5"
                  :class="{'exceed':sms.charExceed}"
                  v-on:keydown="charCountUpdate" v-on:keyup="charCountUpdate"
                  :placeholder="$t('consumer.list.message')" ref="notifMsg"></textarea>
                <i class="far fa-smile fa-lg emoji-trigger" @click.stop
                  @click="sms.showEmoji = !sms.showEmoji"></i>
                <span class="error-msg">{{ sms.messageError }}</span>
                <!-- <span :class="{'char-count':true, 'exceed':sms.charExceed}">
                  {{ $t('consumer.list.charLeft', {count: sms.charCount}) }}
                </span> -->
              </div>

              <div :class="{'data-field':true, 'has-error':!!sms.fileError}" v-if="false">
                <div class="label">{{ $t('consumer.list.img') }}:</div>
                <div class="file-box">
                  <input type="file" name="image" accept="image/*" v-if="sms.fileReady"
                    @change="setImage" class="input-file" ref="fileInput" />
                  <i class="fas fa-times fa-lg" @click="cleanFileInput"
                    v-if="!!sms.file"></i>
                </div>
                <span class="error-msg">{{ sms.fileError }}</span>
              </div>

              <div @click="checkFileUpload"
                :class="{'button cta warning block':true, 'disabled':disableNotifButton}">
                {{ $t('consumer.list.send') }}
              </div>
              <a class="cancel-notif" @click="closeSMSForm">{{ $t('consumer.list.cancel') }}</a>
            </div>

            <div v-show="!!sms.errorMsg" class="error">
              <i class="far fa-frown fa-5x"></i>
              <p>{{ $t('consumer.list.errorMsg') }}</p>
              <code>{{ sms.errorMsg }}</code>
              <div class="button cta block small error"
                @click="closeSMSForm">{{ $t('consumer.list.close') }}</div>
            </div>

            <div v-show="sms.success" class="success-box">
              <i class="far fa-check-circle fa-5x"></i>
              <p>{{ $t('consumer.list.sendNotifSuccess') }}</p>
              <div class="button cta block small success"
                @click="closeSMSForm">{{ $t('consumer.list.close') }}</div>
            </div>

            <transition name="slide-left">
              <div @click.stop v-show="sms.showEmoji" class="emoji-box">
              <picker :style="emojiStyle" :exclude="['recent']" @select="addEmoji" />
              </div>
            </transition>

            <transition name="pop">
              <div class="loader" v-show="sms.loading">
                <div>
                  <i class="fas fa-spinner fa-spin"></i>
                  <span>{{ $t('consumer.list.sendingNotif') }}</span>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue'
import ApiSMS from '@/modules/api/provider/sms'

export default {
  name: 'sms-modal',
  props: ['isList', 'provId', 'removeAllActiveUserOption', 'hideTargetOption', 'showGeofenceOption'],
  data () {
    return {
      sms: {
        showForm: false,
        target: 'all',
        targetMessage: '',
        geofence: {
          show: false,
          type: '',
          brand: '',
          id: '',
          loading: false,
          list: [],
          error: {
            type: '',
            brand: '',
            id: '',
          },
        },
        isPushNotif: true,
        isSendEmail: false,
        brand: '',
        brandErrorMsg: '',
        title: '',
        titleError: '',
        message: '',
        messageError: '',
        charCount: 180,
        charExceed: false,
        showEmoji: false,
        file: '',
        fileReady: true,
        uploadedUrl: '',
        fileError: '',
        loading: false,
        errorMsg: '',
        success: false
      },
      selected: [],
      // disableNotifButton: false
    }
  },
  components: {Picker},
  computed: {
    // provId () { return this.$route.params.id },
    disableNotifButton () {
      let zeroTarget = this.sms.target === 'selected' && !this.selected.length
      this.sms.targetMessage = zeroTarget ? this.$t('consumer.list.zeroSelected') : ''

      let geofenceCheck = true
      if (this.sms.target === 'geofence' && (!this.sms.geofence.type ||
        !this.sms.geofence.id || (this.sms.geofence.type === 'serviceArea' && !this.sms.geofence.brand))
      ) {
        geofenceCheck = false
      }

      return zeroTarget || this.sms.message === '' || this.sms.charExceed ||
        this.sms.fileError !== '' || (!this.sms.isPushNotif && !this.sms.isSendEmail) || !geofenceCheck
    },
    emojiStyle () { return {'width': '100%', 'height': '100%'} },
    brands () { return this.$store.state.brands.list }
  },
  methods: {
    showSMSForm () {
      if (this.provId.length > 0) {
        this.sms.target = 'selected'
        this.sms.geofence.show = false
      }
      this.sms.showForm = true
      this.sms.messageError = ''
    },
    closeSMSForm () {
      if (this.sms.showEmoji) {
        this.closeEmoji()
        return
      }

      if (this.sms.loading) { return }
      this.sms.showForm = false
      this.sms.brandErrorMsg = ''
      this.sms.errorMsg = ''
      this.sms.success = false
    },
    closeEmoji () {
      if (this.sms.showEmoji) {
        this.sms.showEmoji = false
      }
    },
    charCountUpdate () {
      this.sms.charCount = 180 - (this.sms.message.length)
    },
    addEmoji (emoji) {
      this.sms.showEmoji = false

      let textarea = this.$refs.notifMsg
      let cursorPosition = textarea.selectionEnd
      let start = this.sms.message.substring(0, textarea.selectionStart)
      let end = this.sms.message.substring(textarea.selectionStart)
      let text = start + emoji.native + end
      this.sms.message = text
      textarea.focus()
      let self = this
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length
        self.charCountUpdate()
      })
    },
    cleanFileInput () {
      this.sms.file = ''
      this.sms.fileError = ''
      this.sms.fileReady = false
      this.$nextTick(() => {
      	this.sms.fileReady = true
      })
    },
    checkFileUpload () {
      let self = this
      if (this.sms.file) {

        let fd = new FormData()
        fd.append('pic', self.sms.file, 'consumer-notif.png')

        self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
          header: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.body.success) {
            self.sms.uploadedUrl = res.body.data.url
            self.submitNotif()
          }
        })
        return
      }

      self.submitNotif()
    },
    submitNotif () {
      let self = this

      this.sms.messageError = ''
      if (this.sms.message === '') {
        this.sms.messageError = 'This field cannot be empty.'
        return
      }

      let selectedId = self.isList ? self.provId : [self.provId]
      let data = {
        title: self.sms.title,
        message: self.sms.message,
        // image: self.sms.uploadedUrl,
        contactID: selectedId,
      }

      self.sms.brandErrorMsg = ''
      if (self.sms.target === 'all') {
        // if (!self.sms.brand) {
        //   self.sms.brandErrorMsg = self.$t('consumer.list.emptyBrand')
        //   return
        // }
        data.brandId = self.sms.brand
      }

      if (self.sms.target === 'geofence') {
        data.geofenceId = self.sms.geofence.id
        delete data.contactID
      }

      self.sms.loading = true
      ApiSMS.send(self, data, function (res) {
        self.sms.loading = false
        self.sms.success = true
        self.sms.title = ''
        self.sms.message = ''
        self.sms.uploadedUrl = ''
        self.cleanFileInput()
      })
    },
    targetUpdate () {
      this.sms.geofence.show = this.sms.target === 'geofence'
    },
    updateGeofenceList () {
      let self = this
      if (self.sms.geofence.loading) { return }

      if (self.sms.geofence.type === 'serviceArea' && !self.sms.geofence.brand) {
        return
      }

      self.sms.geofence.loading = true
      self.sms.geofence.list = []

      let request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        pageNum: 1,
        pageSize: 999,
        order: 'priority'
      }
      self.sms.geofence.id = ''
      if (self.sms.geofence.type === 'serviceArea') {
        request.brandId = self.sms.geofence.brand
        self.$sdk.get('/servicearea', request, r => {
          self.sms.geofence.loading = false
          if (r.error) {
            console.log('ERROR:', r.error.message)
            return
          }

          r.list.forEach(geofence => {
            self.sms.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            })
          })
        }, '2.0')
      } else {
        request.type = self.sms.geofence.type
        self.$sdk.get('/geofences/search', request, r => {
          self.sms.geofence.loading = false
          if (r.error) {
            console.log('ERROR:', r.error.message)
            return
          }

          r.list.forEach(geofence => {
            self.sms.geofence.list.push({
              id: geofence.id,
              name: geofence.name
            })
          })
        })
      }
    }
  },
  watch: {
    provId: function (value) {
      this.selected = this.isList ? value : [value]
    }
  },
  mounted () {
    if (!this.isList) {
      this.sms.target = 'selected'
      this.selected = [this.$route.params.id]
    }
    if (this.removeAllActiveUserOption) {
      this.sms.target = 'selected'
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field{
  position: relative;
  margin-bottom: 20px;
  &.reduce-margin{
    margin-bottom: 12px;
  }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 3px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 5px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.35);
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.notification-form{
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  .heading{
    background: #333;
    color: #fff;
    padding: 10px;
    font-size: 18px;
    text-align: center;
  }

  .nf-content{
    padding: 20px;
    position: relative;

    .label{
      font-size: 13px;
      color: #555;
    }
    label{
      display: block;
      font-size: 14px;
      color: #555;
      margin-bottom: 2px;
      cursor: pointer;

      input{
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .textarea-box{
      position: relative;
      margin-bottom: 20px;
      padding-bottom: 20px;

      .emoji-trigger{
        position: absolute;
        top: 133px;
        right: 0;
        color: #aaa;
        cursor: pointer;
      }
      .error-msg{
        font-size: 11px;
        line-height: 1.6;
        color: #f20d0d;
        font-style: italic;
        display: block;
      }
    }
    textarea{
      margin: 0;
      padding: 10px;
      width: 100%;
      resize: none;
      background: #fdfdfd;
      font-size: 14px;
      outline: none;
      color: #333;
      border-color: #ddd;
      box-shadow: 1px 1px 3px rgba(0,0,0, .05) inset;
      transition: all .3s ease;

      &.exceed{
        border-color: #d61613;
        background: #fff0f0;
      }
    }
    .char-count{
      font-size: 12px;
      color: #777;
      display: block;
      text-align: right;
      line-height: 1;
      margin-top: 5px;

      &.exceed{ color:#f00; }
    }
    .cancel-notif{
      display: block;
      font-size: 13px;
      margin: 10px 0 0;
      text-align: center;
      cursor: pointer;
      color: #bbb;
      transition: all .5s ease;
      &:hover{ color:#333; }
    }
    .file-box{
      position: relative;

      input{
        padding: 5px 25px 5px 5px;
        margin:0;
        font-size: 14px;
      }
      i{
        position: absolute;
        z-index: 2;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: #fd4a38;
        cursor: pointer;
      }
    }
  }

  .error{
    text-align: center;
    i{ color:#fd4a38; }
    p{ margin: 5px 0 20px; }
    code{
      border:2px solid #fd4a38;
      padding: 10px;
      width: 100%;
      display: block;
      font-size: 14px;
      background: #ffeeec;
      border-radius: 3px;
      margin-bottom: 30px;
    }
  }

  .success-box{
    text-align: center;
    i{ color: #26d97a; }
  }

  .loader{
    position: absolute;
    top:0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);

    div{
      position: absolute;
      top:50%;
      left: 0;
      height: 50px;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;

      i{ color: #45e7f9; }
      span{
        color: #fff;
        font-size: 21px;
        font-weight: 600;
        margin-left: 5px;
        text-shadow: 1px 1px 1px rgba(0,0,0, .4);
      }
    }
  }
}

.select-box{
  position: relative;

  .select-loader{
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 13px;
    transform: translate(-50%, -50%);
    z-index: 2;
    color: #a2a6aa;
    
    i{
      vertical-align: -1px;
      margin-right: 3px;
    };
  }
  select{
    position: relative;
    z-index: 1;
  }
}

.emoji-box{
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 2;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/App/SMSModal.vue